
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="active = false">
        <template #header>
          <h4 class="not-margin">
            Editar registro
          </h4>
        </template>


        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Clave</label>
                        <vs-input  type="text" class="pt-0"
                            v-model="clave"
                            placeholder="Clave" >
                            <template #message-danger v-if="errorFields.includes('clave')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Nombre</label>
                        <vs-input  type="text" class="pt-0"
                            v-model="nombre"
                            placeholder="Nombre" >
                            <template #message-danger v-if="errorFields.includes('nombre')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Prioridad</label>
                        <vs-input  type="text" class="pt-0"
                            v-model="prioridad"
                            placeholder="Prioridad" >
                            <template #message-danger v-if="errorFields.includes('prioridad')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Tipo
                        </label>
                        <vs-select class="pt-0" placeholder="Seleccionar tipo" v-model="tipo">
                            <template #message-danger v-if="errorFields.includes('tipo')">
                                Requerido
                            </template>
                            <vs-option label="Abono" value="abono">
                                Abono
                            </vs-option>
                            <vs-option label="Cargo" value="cargo">
                                Cargo
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4" v-if="tipo === 'abono'">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Cargo
                        </label>
                        <vs-select filter :key="cargoId" class="pt-0" placeholder="Seleccionar cargo" v-model="cargo">
                            <template #message-danger v-if="errorFields.includes('cargo')">
                                Requerido
                            </template>
                            <vs-option v-for="(option,i) in cargos" :key="i" :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4" v-if="tipo === 'cargo'">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Abono
                        </label>
                        <vs-select filter :key="abonoId" class="pt-0" placeholder="Seleccionar abono" v-model="abono">
                            <template #message-danger v-if="errorFields.includes('abono')">
                                Requerido
                            </template>
                            <vs-option v-for="(option,i) in abonos" :key="i" :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Gravable
                        </label>
                        <vs-select filter class="pt-0" placeholder="Seleccionar" v-model="gravable">
                            <template #message-danger v-if="errorFields.includes('gravable')">
                                Requerido
                            </template>
                            <vs-option label="Si" value="si">
                                Si
                            </vs-option>
                            <vs-option label="No" value="no">
                                No
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Reembolsable 
                        </label>
                        <vs-select filter class="pt-0" placeholder="Seleccionar" v-model="reembolsable">
                            <template #message-danger v-if="errorFields.includes('reembolsable')">
                                Requerido
                            </template>
                            <vs-option label="Si" value="si">
                                Si
                            </vs-option>
                            <vs-option label="No" value="no">
                                No
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Deducible  
                        </label>
                        <vs-select filter class="pt-0" placeholder="Seleccionar" v-model="deducible">
                            <template #message-danger v-if="errorFields.includes('deducible')">
                                Requerido
                            </template>
                            <vs-option label="Si" value="si">
                                Si
                            </vs-option>
                            <vs-option label="No" value="no">
                                No
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Categoría  
                        </label>
                        <vs-select filter class="pt-0" placeholder="Seleccionar" v-model="categoria">
                            <template #message-danger v-if="errorFields.includes('categoria')">
                                Requerido
                            </template>
                            <vs-option v-for="(option, i) in categorias" :key="i" :label="option.nombre" :value="option.valor">
                                {{option.nombre}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postEditarCodigoDetalle()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'info',
      'selectInfo',
      'institucion',
      'cicloEscolar'
    ],
    data:() => ({
        active: false,
        nombre: '',
        clave: '',
        prioridad: '',
        tipo: '',
        gravable: '',
        reembolsable: '',
        deducible: '',
        categoria: '',
        errorFields: [],
        categorias: [
            {
                "valor": 'inscripcion',
                "nombre": "Inscripción"
            },
            {
                "valor": 'colegiatura',
                "nombre": "Colegiatura"
            },
            {
                "valor": 'promocion',
                "nombre": "Promoción"
            },
            {
                "valor": 'servicio',
                "nombre": "Servicio"
            },
            {
                "valor": 'rebaja',
                "nombre": "Rebaja"
            },
            {
                "valor": 'beca',
                "nombre": "Beca"
            }
        ],
        cargos: [],
        cargo: '',
        cargoId: (new Date()).getTime(),
        abonos: [],
        abono: '',
        abonoId: (new Date()).getTime(),
        clave: ''
    }),
    methods: {
        async getInfoModal(){
            try{
                const { data: response } = await academico.getInfoModal(this.selectInfo.id)
                this.idEditar = response.id
                this.nombre = response.nombre
                this.clave = response.clave
                this.prioridad = response.prioridad
                this.tipo = response.tipo
                this.gravable = response.gravable
                this.reembolsable = response.reembolsable
                this.deducible = response.deducible
                this.categoria = response.categoria
                if(this.tipo === 'abono' && response.cargo[0].id){
                    this.cargo = response.cargo[0].id
                }else if(this.tipo === 'cargo' && response.codigo_detalle_id){
                    this.abono = response.codigo_detalle_id
                }
            }catch{

            }
        },
        async getListadoTipoAbono(){
            try{
                const params = {
                    'invertir': 'si',
                    'tipo': this.selectInfo.tipo
                }
                const { data: response } = await academico.getListadoTipoAbono(params)
                this.cargos = response
                this.cargoId = (new Date()).getTime()
                this.abonos = response
                this.abonoId = (new Date()).getTime()

            }catch{

            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.clave)) {
                this.errorFields.push('clave')
            }
            if (!this.checkByType ('string', this.nombre)) {
                this.errorFields.push('nombre')
            }
            if (!this.checkByType ('string', this.prioridad)) {
                this.errorFields.push('prioridad')
            }
            if (!this.checkByType ('string', this.tipo)) {
                this.errorFields.push('tipo')
            }
            if(this.tipo === 'abono'){
                if (!this.checkByType ('string', this.cargo)) {
                    this.errorFields.push('cargo')
                }
            }
            if (!this.checkByType ('string', this.gravable)) {
                this.errorFields.push('gravable')
            }
            if (!this.checkByType ('string', this.reembolsable)) {
                this.errorFields.push('reembolsable')
            }
            if (!this.checkByType ('string', this.deducible)) {
                this.errorFields.push('deducible')
            }
            if (!this.checkByType ('string', this.categoria)) {
                this.errorFields.push('categoria')
            }
            if (!this.errorFields.length){
                const formData = new FormData()
                formData.append("clave", this.clave)
                formData.append("nombre", this.nombre)
                formData.append("prioridad", this.prioridad)
                formData.append("tipo", this.tipo)
                if(this.tipo === 'abono'){
                    formData.append("codigo_detalle_id", this.cargo)
                }
                if(this.tipo === 'cargo'){
                    formData.append("codigo_detalle_id", this.abono)
                }
                formData.append("gravable", this.gravable)
                formData.append("reembolsable", this.reembolsable)
                formData.append("deducible", this.deducible)
                formData.append("categoria", this.categoria)
                return formData
            } else {
                return null
            }
        },
        async postEditarCodigoDetalle(){
            const info = this.sanityForm()
            if(info){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await academico.postEditarCodigoDetalle(info, this.idEditar)
                    loading.close()
                    this.active = false
                    this.getInfoModal()
                    this.$emit('refreshTable')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se edito con éxito el registro.'
                    })
                }catch{
                    loading.close()
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salió mal.',
                        text: 'Póngase en contacto con el administrador.'
                    })
                }
            }
        },
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      selectInfo(){
          this.getInfoModal()
          this.getListadoTipoAbono()
      }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>